import React from 'react'
import Nav from "../components/Nav"
import Hero from '../components/Hero'
import AboutUs from '../components/AboutUS'
import FeaturedProducts from '../components/FeaturedProducts'
import WhyChooseUs from '../components/WhyChooseUs '
import PromoSection from '../components/PromoSection'
import LatestProducts from '../components/LatestProducts'
import CustomerReviews from '../components/CustomerReviews'
import AboutSection from '../components/AboutSection'
import Footer from '../components/Footer'
const Home = () => {
  return (
    <div>
        <Nav/>
        <Hero/>
        <AboutUs/>
        <LatestProducts/>
        <WhyChooseUs/>
        <PromoSection/>
        <FeaturedProducts/>
        <CustomerReviews/>
        <AboutSection/>
        <Footer/>
    </div>
  )
}

export default Home